import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { sortPartRequest } from "../../../actions/course-author/common";
import { IState } from "../../../App/reducer";
import { accountId as currentAccountId, currentCourse, currentCourseId } from "../../../selectors/selectors";
import { AssessmentComponent } from "./Assessment.component";
import { IAssessmentDispatchProps, IAssessmentStateProps } from "./types";

const mapStateToProps = (state: IState): IAssessmentStateProps => ({
  accountId: currentAccountId(state),
  course: currentCourse(state),
  courseId: currentCourseId(state),
});

const mapDispatchToProps = (dispatch: Dispatch): IAssessmentDispatchProps =>
  bindActionCreators({ sortPart: sortPartRequest }, dispatch);

export const Assessment = connect(mapStateToProps, mapDispatchToProps)(AssessmentComponent);
